export default __webpack_public_path__ + "static/media/calendar_inactive.4f829110.svg";